<!--
  Renders export notifications pinned bottom-right, separate from the global
  top-right Nuxt UI toaster, so they never overlap the top-right Export popover.
  Mounted once from App.vue; reads the shared queue from useExportNotifications.
-->
<template>
  <Teleport to="body">
    <div
      v-if="exportToasts.length"
      class="fixed right-4 bottom-4 z-[60] flex flex-col gap-3"
      data-testid="export-toast-host"
    >
      <ExportNotificationToast
        v-for="t in exportToasts"
        :key="t.id"
        :type="t.type"
        :success="t.success"
        :file-name="t.fileName"
        :download-url="t.downloadUrl"
        @close="dismissExportToast(t.id)"
      />
    </div>
  </Teleport>
</template>

<script setup>
import { useExportNotifications } from '@/composables/useExportNotifications';
import ExportNotificationToast from '@/components/shared/export/ExportNotificationToast.vue';

const { exportToasts, dismissExportToast } = useExportNotifications();
</script>
